import { useWindowSize } from "hooks/useWindowSize";
import type { SbEditableComponentProps } from "types/storyblok";
import type { ImageCTAProps } from "./ImageCTA.d";
import ImageCTADesktop from "./ImageCTADesktop/ImageCTADesktop";
import ImageCTAMobile from "./ImageCTAMobile/ImageCTAMobile";
import { BG_IMAGE_AHP_DESKTOP_URL, BG_IMAGE_AHP_MOBILE_URL, BG_IMAGE_BASIC_URL } from "./ImageCTA.config";

const setImageUrl = (imageUrl: string, variant: ImageCTAProps["variant"], isTabletOrDesktop?: boolean) => {
  if (imageUrl) return imageUrl;
  if (variant === "ahPlus") {
    return isTabletOrDesktop ? BG_IMAGE_AHP_DESKTOP_URL : BG_IMAGE_AHP_MOBILE_URL;
  }
  return BG_IMAGE_BASIC_URL;
};

const ImageCTA = (props: SbEditableComponentProps<ImageCTAProps>) => {
  const { imageUrl, variant } = props;
  const windowSize = useWindowSize();

  if (!windowSize) return null;

  const { isTablet } = windowSize;

  return isTablet ? (
    <ImageCTAMobile {...props} imageUrl={setImageUrl(imageUrl, variant, isTablet)} />
  ) : (
    <ImageCTADesktop {...props} imageUrl={setImageUrl(imageUrl, variant, isTablet)} />
  );
};

export default ImageCTA;
